<template>
  <section class="title text-center pt-4">
    <h6 class="fontsize-h2">{{this.title}}</h6>
<!--    <div><img src="@/assets/images/backgrounds/ba" alt=""></div>-->
  </section>
</template>

<script>
export default {
  name: "Title",
  props:{
    title:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped>
.title{
  background-image: url("../assets/images/backgrounds/backTitle.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position-x: center;
}
.title h6{
  color: #222;
  font-weight: 600;
}
</style>